import React from 'react';
import './LocalPackageTrips.css';

const LocalPackageTrips = () => {
  const packageData = [
    
    {
      type: '5 hrs & 50 kms',
      sedan: '₹1,500',
      muv: '₹2,150'
    },
    {
      type: '6 hrs & 60 kms',
      sedan: '₹1,800',
      muv: '₹2,400'
    },
    {
      type: '7 hrs & 70 kms',
      sedan: '₹2,100',
      muv: '₹2,750'
    },
    {
      type: '8 hrs & 80 kms',
      sedan: '₹2,400',
      muv: '₹3,000'
    },
    {
      type: '9 hrs & 90 kms',
      sedan: '₹2,500',
      muv: '₹3,250'
    },
    {
      type: '10 hrs & 100 kms',
      sedan: '₹2,650',
      muv: '₹3,600'
    },
    {
      type: '11 hrs & 110 kms',
      sedan: '₹2,750',
      muv: '₹3,850'
    },
    {
      type: '12 hrs & 120 kms',
      sedan: '₹3,000',
      muv: '₹4,100'
    },
    {
      type: '13 hrs & 130 kms',
      sedan: '₹3,250',
      muv: '₹4,450'
    },
    {
      type: '14 hrs & 140 kms',
      sedan: '₹3,500',
      muv: '₹4,800'
    },
    {
      type: '15 hrs & 150 kms',
      sedan: '₹3,750',
      muv: '₹5,100'
    }
  ];

  return (
    <div id="local-trips" className="local-packages">
      <div className="packages-container">
        <h2 className="packages-title">Metro City Package</h2>
        
        <div className="packages-table-container">
          <table className="packages-table">
            <thead>
              <tr className="table-header">
                <th className="header-cell">Package Type</th>
                <th className="header-cell">SEDAN</th>
                <th className="header-cell">MUV</th>
              </tr>
            </thead>
            <tbody>
              {packageData.map((row, index) => (
                <tr key={index} className="table-row">
                  <td className="row-label">{row.type}</td>
                  <td className="row-data">{row.sedan}</td>
                  <td className="row-data">{row.muv}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="additional-charges">
          <div className="charge-item">
            <span className="charge-label">Additional Hrs:</span>
            <span className="charge-value">₹250/hr (Sedan) | ₹350/hr (MUV)</span>
          </div>
          <div className="charge-item">
            <span className="charge-label">Additional KMs:</span>
            <span className="charge-value">₹20/km (Sedan) | ₹25/km (MUV)</span>
          </div>
        </div>
        
        <div className="disclaimer">
          <p className="disclaimer-text">
            Toll fees, Inter-State Permit charges (if any) are extra.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LocalPackageTrips;